import { gql } from 'graphql-request';
import { QUERY_SQL_FRAGMENT } from '../../hooks/useQuerySql';

const QueryObjectFragment = `
  fragment QueryObjectFields on DwQueryResponse {
    rows {
      data
      id
    }
    queryId
    totalRowCount
    totals {
      data
      id
    }
  }
`;

export const SearchLogsQuery = gql`
  query SearchLogsQuery($req: Json!) {
    queryObject(value: $req) {
      ...QueryObjectFields
    }
  }

  ${QueryObjectFragment}
`;

export const SearchLogsTotalsQuery = gql`
  query SearchLogsTotalsQuery($req: Json!) {
    queryObject(value: $req) {
      ...QueryObjectFields
    }
  }

  ${QueryObjectFragment}
`;

export const SearchLogsAdvancedQuery = gql`
  query SearchLogsAdvancedQuery($req: Json!) {
    querySql(value: $req) {
      ...QuerySqlFields
    }
  }

  ${QUERY_SQL_FRAGMENT}
`;

export const LHSearchQuery = gql`
  query LHSearchQuery($req: Json!) {
    LHSearch(value: $req) {
      queryId
      totalRowCount
      stats {
        timeTakenMs
        startTime
      }
      responseSchema {
        name
        type
      }
      rows {
        id
        data
      }
    }
  }
`;

export const LHDatasetsQuery = gql`
  query LHDatasetsQuery($req: Json!) {
    LHDatasets(value: $req) {
      name
    }
  }
`;

export const LHDatasetColumnsQuery = gql`
  query LHDatasetColumnsQuery($req: Json!) {
    LHDatasetColumns(value: $req) {
      name
      columns {
        name
        type
      }
    }
  }
`;

export const SearchLogsPieQuery = gql`
  query SearchLogsPieQuery($req: Json!) {
    queryObject(value: $req) {
      ...QueryObjectFields
    }
  }

  ${QueryObjectFragment}
`;

export const SearchLogsHistogramQuery = gql`
  query SearchLogsHistogramQuery($req: Json!) {
    queryObject(value: $req) {
      ...QueryObjectFields
    }
  }

  ${QueryObjectFragment}
`;

export const SearchLogsFacetsQuery = gql`
  query SearchLogsFacetsQuery($req: Json!) {
    queryObject(value: $req) {
      ...QueryObjectFields
    }
  }

  ${QueryObjectFragment}
`;

export const SourcesDistributionQuery = gql`
  query SourcesDistributionQuery($req: Json!) {
    queryObject(value: $req) {
      ...QueryObjectFields
    }
  }

  ${QueryObjectFragment}
`;

export const FacetResultsQuery = gql`
  query FacetResultsQuery($req: Json!) {
    querySql(value: $req) {
      ...QuerySqlFields
    }
  }

  ${QUERY_SQL_FRAGMENT}
`;
